<ng-container>
  <ng-container *ngLet="breakPointObserve$ | async as screenRes">
    <ng-container *ngIf="screenRes !== 2; else mobileTemplate">
      <app-carousel-card
        [textColorClass]="textColorClass"
        class="small-card-carousel"
        [criteria]="criteria"
        [criteriaLink]="criteriaLink"
        [clickable]="clickable"
        [carouselData]="smallCardData"
        [isFloating]="isFloating"
        [class.floating]="isFloating"
        (cardClick)="cardClick.emit()"
        [hasShowDownloads]="hasShowDownloads"
      ></app-carousel-card>
    </ng-container>

    <ng-template #mobileTemplate>
      <div class="card-container ml8 mr8">
        <a *ngIf="criteriaLink" class="title-container clickable-link" (click)="setFilter()" [routerLink]="[criteriaLink]">
          <svg [icon]="smallCardData?.icon" class="svg32 mr4" [ngClass]="textColorClass" />
          <span class="title" [ngClass]="textColorClass">{{ smallCardData?.title ?? '' | translate }}</span>
        </a>

        <a *ngIf="!criteriaLink" class="title-container clickable-link" (click)="setFilter()">
          <svg [icon]="smallCardData?.icon" class="svg32 mr4" [ngClass]="textColorClass" />
          <span class="title" [ngClass]="textColorClass">{{ smallCardData?.title ?? '' | translate }}</span>
        </a>

        <div class="horizontal-scroll" *ngIf="smallCardData && smallCardData.data; else loading">
          <app-small-card
            [clickable]="clickable"
            [data]="card"
            [hasShowDownloads]="hasShowDownloads"
            *ngFor="let card of smallCardAllData"
          ></app-small-card>
        </div>
        <div [ngStyle]="{'background-color': grayHideScroll ? 'var(--secondary-10-color)' : ''}" class="scroll-hider"></div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="loader-wrapper">
    <app-loader class="loader"></app-loader>
  </div>
</ng-template>
